import useMediaQuery from './useMediaQuery';
import { useLocation } from '@remix-run/react';
import { Routes } from '../constants/routes';

function useIsMobileNavigation() {
  const { isTabletLg, isTabletLgx } = useMediaQuery();
  const { pathname } = useLocation();

  const showMobile =
    isTabletLg || (pathname === Routes.SizingReference && isTabletLgx);

  return showMobile;
}

export default useIsMobileNavigation;
